<template>
    <div class="lov-management-container">
        <!-- Header Section -->
        <el-card class="header-card" shadow="never">
            <el-row :gutter="20" align="middle">
                <el-col :span="24">
                    <h2 style="margin: 0; color: #303133;">Manajemen List of Values (LOV)</h2>
                    <p style="margin: 5px 0 0 0; color: #909399; font-size: 14px;">Kelola daftar nilai referensi yang digunakan dalam sistem</p>
                </el-col>
            </el-row>
        </el-card>

        <!-- Filter Section -->
        <el-card class="filter-card" shadow="never">
            <el-row :gutter="20" align="middle">
                <el-col :md="8">
                    <el-select 
                        v-model="filter_lov_id" 
                        filterable 
                        clearable
                        placeholder="Pilih kategori LOV" 
                        @change="filterLov"
                        @clear="clearFilter"
                        style="width: 100%"
                        :loading="loadingLovList"
                    >
                        <el-option 
                            v-for="lov in lovList" 
                            :key="lov.lov_id" 
                            :label="lov.lov_id" 
                            :value="lov.lov_id" 
                        />
                    </el-select>
                </el-col>
                <el-col :md="16" style="text-align: right;">
                    <el-button 
                        type="primary" 
                        @click="showForm()"
                        style="background-color: #409EFF; border-color: #409EFF; color: white;"
                    >
                        <el-icon style="margin-right: 5px;"><Plus /></el-icon>
                        Tambah
                    </el-button>
                </el-col>
            </el-row>
        </el-card>

        <!-- Table Section -->
        <el-card shadow="never">
            <el-table 
                :data="tableData" 
                v-loading="loading"
                empty-text="Tidak ada data LOV"
                style="width: 100%"
                :stripe="true"
            >
                <el-table-column type="index" width="60" label="No" align="center" />
                <el-table-column prop="lov_id" label="Kategori" min-width="150" show-overflow-tooltip />
                <el-table-column prop="lov_label" label="Label" min-width="200" show-overflow-tooltip />
                <el-table-column prop="lov_value" label="Nilai" min-width="150" show-overflow-tooltip />
                <el-table-column prop="lov_order" label="Urutan" width="100" align="center">
                    <template #default="scope">
                        <el-tag size="small">{{ scope.row.lov_order || 0 }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="Aksi" width="150" align="center">
                    <template #default="scope">
                        <div style="display: flex; gap: 8px; justify-content: center;">
                            <el-tooltip content="Ubah Data" placement="top">
                                <el-button 
                                    size="small" 
                                    type="primary"
                                    style="background-color: #409EFF; border-color: #409EFF; color: white;"
                                    @click="showUbah(scope)"
                                >
                                    <el-icon><Edit /></el-icon>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip content="Hapus Data" placement="top">
                                <el-popconfirm 
                                    title="Apakah Anda yakin ingin menghapus data ini?" 
                                    confirm-button-text="Ya"
                                    cancel-button-text="Tidak"
                                    @confirm="hapus(scope)"
                                >
                                    <template #reference>
                                        <el-button 
                                            size="small" 
                                            type="danger"
                                            style="background-color: #F56C6C; border-color: #F56C6C; color: white;"
                                        >
                                            <el-icon><Delete /></el-icon>
                                        </el-button>
                                    </template>
                                </el-popconfirm>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            
            <!-- Pagination -->
            <div style="margin-top: 20px; display: flex; justify-content: center;">
                <el-pagination 
                    v-model:current-page="currentPage" 
                    v-model:page-size="pageSize" 
                    :page-sizes="[10, 20, 50, 100]"
                    :layout="paginationLayout"
                    :total="tableCount" 
                    @size-change="handleSizeChange" 
                    @current-change="handleCurrentChange"
                    :background="true"
                />
            </div>
        </el-card>

        <!-- Form Dialog -->
        <el-dialog 
            v-model="dialogFormVisible" 
            :title="form.id ? 'Ubah Data LOV' : 'Tambah Data LOV'" 
            width="600px"
            :close-on-click-modal="false"
        >
            <el-form 
                :model="form" 
                label-width="140px" 
                :rules="rules" 
                ref="ruleForm"
                label-position="right"
            >
                <el-form-item label="Kategori" prop="lov_id">
                    <el-input 
                        v-model="form.lov_id" 
                        placeholder="Masukkan kategori LOV (contoh: STATUS_DOKUMEN)"
                        :disabled="form.id !== ''"
                    />
                </el-form-item>
                <el-form-item label="Label" prop="lov_label">
                    <el-input 
                        v-model="form.lov_label" 
                        placeholder="Masukkan label yang akan ditampilkan"
                    />
                </el-form-item>
                <el-form-item label="Nilai" prop="lov_value">
                    <el-input 
                        v-model="form.lov_value" 
                        placeholder="Masukkan nilai yang akan disimpan"
                    />
                </el-form-item>
                <el-form-item label="Urutan" prop="lov_order">
                    <el-input-number 
                        v-model="form.lov_order" 
                        :min="0" 
                        :max="9999"
                        placeholder="Urutan tampilan"
                    />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">Batal</el-button>
                    <el-button 
                        type="primary" 
                        @click="form.id ? ubah() : tambah()"
                        :loading="submitting"
                    >
                        {{ form.id ? 'Simpan' : 'Tambah' }}
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { Plus, Edit, Delete } from '@element-plus/icons-vue'

export default {
    name: 'LovView',
    data() {
        return {
            Plus, Edit, Delete,
            tableData: [],
            tableCount: 0,
            currentPage: 1,
            pageSize: 20,
            dialogFormVisible: false,
            filter_lov_id: '',
            lovList: [],
            loading: false,
            loadingLovList: false,
            submitting: false,
            form: {
                id: '',
                lov_id: '',
                lov_label: '',
                lov_value: '',
                lov_order: 0
            },
            rules: {
                lov_id: [
                    { required: true, message: 'Harap masukkan kategori LOV', trigger: 'blur' },
                    { min: 3, message: 'Kategori minimal 3 karakter', trigger: 'blur' }
                ],
                lov_label: [
                    { required: true, message: 'Harap masukkan label', trigger: 'blur' }
                ],
                lov_value: [
                    { required: true, message: 'Harap masukkan nilai', trigger: 'blur' }
                ],
                lov_order: [
                    { required: true, message: 'Harap masukkan urutan', trigger: 'blur' },
                    { type: 'number', message: 'Urutan harus berupa angka', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        apiHeaders() {
            return {
                'Authorization': `Bearer ${this.$store.state.auth_token}`
            }
        },
        baseUrl() {
            return this.$store.state.base_url
        },
        paginationLayout() {
            return window.innerWidth < 768 
                ? 'prev, pager, next' 
                : 'total, sizes, prev, pager, next, jumper'
        }
    },
    mounted() {
        this.fetchData()
        this.getLOVList()
    },
    methods: {
        filterLov(val) {
            this.currentPage = 1
            this.fetchData(val)
        },
        clearFilter() {
            this.filter_lov_id = ''
            this.currentPage = 1
            this.fetchData()
        },
        handleSizeChange() {
            this.currentPage = 1
            this.fetchData(this.filter_lov_id)
        },
        handleCurrentChange() {
            this.fetchData(this.filter_lov_id)
        },
        async fetchData(lov_id = '') {
            this.loading = true
            try {
                const params = {
                    limit: this.pageSize,
                    offset: (this.currentPage - 1) * this.pageSize
                }

                if (lov_id) {
                    params.lov_id = lov_id
                }

                const response = await axios.get(`${this.baseUrl}/api/lov`, {
                    params,
                    headers: this.apiHeaders
                })
                
                this.tableData = response.data.data
                this.tableCount = response.data.count
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data LOV')
            } finally {
                this.loading = false
            }
        },
        showForm() {
            this.resetForm()
            this.dialogFormVisible = true
        },
        showUbah(selected) {
            this.form = { ...selected.row }
            this.dialogFormVisible = true
        },
        resetForm() {
            this.form = {
                id: '',
                lov_id: '',
                lov_label: '',
                lov_value: '',
                lov_order: 0
            }
        },
        async getLOVList() {
            this.loadingLovList = true
            try {
                const response = await axios.get(`${this.baseUrl}/api/lov_list`, {
                    headers: this.apiHeaders
                })
                
                this.lovList = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil daftar kategori LOV')
            } finally {
                this.loadingLovList = false
            }
        },
        async tambah() {
            try {
                const valid = await this.$refs['ruleForm'].validate()
                if (!valid) return
                
                this.submitting = true
                const postData = {
                    lov_id: this.form.lov_id,
                    lov_label: this.form.lov_label,
                    lov_value: this.form.lov_value,
                    lov_order: this.form.lov_order
                }
                
                await axios.post(`${this.baseUrl}/api/lov`, postData, {
                    headers: this.apiHeaders
                })
                
                ElMessage({
                    message: 'Data LOV berhasil ditambahkan!',
                    type: 'success'
                })
                this.dialogFormVisible = false
                this.fetchData(this.filter_lov_id)
                this.getLOVList()
            } catch (error) {
                this.handleError(error, 'Gagal menambahkan data LOV')
            } finally {
                this.submitting = false
            }
        },
        async ubah() {
            try {
                const valid = await this.$refs['ruleForm'].validate()
                if (!valid) return
                
                this.submitting = true
                const postData = {
                    lov_id: this.form.lov_id,
                    lov_label: this.form.lov_label,
                    lov_value: this.form.lov_value,
                    lov_order: this.form.lov_order
                }
                
                await axios.put(`${this.baseUrl}/api/lov/${this.form.id}`, postData, {
                    headers: this.apiHeaders
                })
                
                this.dialogFormVisible = false
                ElMessage({
                    message: 'Data LOV berhasil diperbarui!',
                    type: 'success'
                })
                this.fetchData(this.filter_lov_id)
            } catch (error) {
                this.handleError(error)
            } finally {
                this.submitting = false
            }
        },
        async hapus(selected) {
            this.loading = true
            try {
                await axios.delete(`${this.baseUrl}/api/lov/${selected.row.id}`, {
                    headers: this.apiHeaders
                })
                
                ElMessage({
                    message: 'Data LOV berhasil dihapus!',
                    type: 'success'
                })
                this.fetchData(this.filter_lov_id)
                this.getLOVList()
            } catch (error) {
                this.handleError(error)
            } finally {
                this.loading = false
            }
        },
        handleError(error, defaultMessage = '') {
            const message = error.response?.data?.message || defaultMessage || 'Terjadi kesalahan'
            ElMessage({
                message,
                type: 'error'
            })
            console.error('Error:', error)
        }
    }
}
</script>

<style scoped>
.lov-management-container {
    padding: 20px;
}

.header-card {
    margin-bottom: 20px;
}

.filter-card {
    margin-bottom: 20px;
}

.el-tag {
    font-weight: bold;
}

@media (max-width: 768px) {
    .lov-management-container {
        padding: 10px;
    }
    
    .el-dialog {
        width: 90% !important;
    }
}
</style>